<template>
  <v-card
    :width="statisticsSizes.cardWidth[expand]"
    :height="statisticsSizes.cardHeight[expand]"
  >
    <v-system-bar>
      <label>{{ title }}</label>
      <v-spacer></v-spacer>
      <v-menu :offset-x="true">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-icon small v-bind="attrs" v-on="{ ...menu }">{{
            icon.filter
          }}</v-icon>
        </template>
        <v-list>
          <v-list-item
            link
            v-for="item in statisticsYears"
            :key="item"
            @click="changeYear(item)"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-icon small @click="resize">{{
        expand ? icon.collapse : icon.expand
      }}</v-icon>
    </v-system-bar>
    <vue-apex-charts
      :height="statisticsSizes.chartHeight[expand]"
      :options="options"
      :series="series"
    ></vue-apex-charts>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { mdiArrowExpand, mdiArrowCollapse, mdiFilter } from '@mdi/js'
import {
  documentsChartStoreData,
  documentsChartStoreActions
} from '../store/documentsChartStoreHelpers'
import { buildSeries, buildOptions } from '../store/documentsChartStoreUtils'

export default {
  name: 'DocumentsChart',
  components: {
    VueApexCharts
  },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      icon: {
        expand: mdiArrowExpand,
        collapse: mdiArrowCollapse,
        filter: mdiFilter
      },
      expand: false,
      yearSelected: this.$moment().year(),
      series: [],
      options: {},
      title: ''
    }
  },
  created() {
    this.title = this.statisticsTitles[this.type]
    this.series = buildSeries(this.type, this.statisticsData, this.yearSelected)
    this.options = buildOptions(
      this.type,
      this.statisticsColors,
      this.statisticsLabelsMonthly,
      this.yearSelected,
      this.theme
    )
    if (!this.statisticsLoading) {
      this.getDocumentStatistics(this.yearSelected)
      this.getYearsDocStatistics()
    }
  },
  computed: {
    ...documentsChartStoreData
  },
  watch: {
    statisticsData: function(value) {
      if (value.anio == this.yearSelected) {
        this.series = buildSeries(this.type, value, this.yearSelected)
        this.$nextTick(() => {
          let newOptions = buildOptions(
            this.type,
            this.statisticsColors,
            this.statisticsLabelsMonthly,
            this.yearSelected
          )
          newOptions.noData.text = ''
          const pscTheme = ( localStorage.getItem('pscThemeDark') || '') === 'true'
          newOptions.theme = { mode: pscTheme ? 'dark' : 'light' }
          this.options = newOptions
          this.title =
            (this.statisticsTitles[this.type] || '') + ' - ' + this.yearSelected
        })
      }
    },
    '$vuetify.theme.dark': function(value) {
      let newOptions = buildOptions(
        this.type,
        this.statisticsColors,
        this.statisticsLabelsMonthly,
        this.yearSelected
      )
      newOptions.theme = { mode: value ? 'dark' : 'light' }
      this.options = newOptions
    }
  },
  methods: {
    ...documentsChartStoreActions,
    changeYear(year) {
      this.getDocumentStatistics(+year)
      this.yearSelected = +year
    },
    resize() {
      if(window.screen.width <= 1280) {
        this.statisticsSizes.cardHeight.true = 450
        this.statisticsSizes.chartHeight.true = 400
      }
      const value = !this.expand
      this.expand = value
      if (value) {
        this.$emit('expand')
      } else {
        this.$emit('collapse')
      }
    }
  }
}
</script>
